var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{staticClass:"filter-menu",attrs:{"left":"","offset-x":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-badge',{attrs:{"color":"marca-1","value":_vm.filtersQuantity,"content":_vm.filtersQuantity,"overlap":""}},[_c('mf-button',{attrs:{"type":"icon","color":"cinza-0","icon":"filter_list"},nativeOn:{"click":function($event){return on.click($event)}}})],1)]}}]),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('v-card',{attrs:{"width":"285px"}},[_c('v-card-text',[_c('p',{staticClass:"title"},[_vm._v("Filtros")]),_vm._t("default"),_c('mf-action-buttons',{attrs:{"primary-button":{
          text: 'Aplicar',
          action: _vm.applyChanges,
          isVisible: true,
          isDisabled: false,
        },"cancel-button":{
          text: 'Limpar',
          action: function () { return _vm.$emit('clear-filters'); },
          isVisible: true,
          isDisabled: false,
        }}})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }